import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProductImageModel } from '@libs/shop/models';
import { ViewportService } from '@libs/shared/services';
import { ImageGalleryMagnifierComponent } from './image-gallery-magnifier';

@Component({
  selector: 'ui-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrl: './image-gallery.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgOptimizedImage,
    ImageGalleryMagnifierComponent,
  ],
})
export class ImageGalleryComponent {
  private readonly viewportService: ViewportService = inject(ViewportService);
  private readonly _currentImage: WritableSignal<ProductImageModel | undefined> = signal(undefined);

  // @TODO - maybe change model or extract the model to a more generic name.
  public images: InputSignal<ProductImageModel[]> = input.required();
  public overlayReferenceElement: InputSignal<HTMLElement | undefined> = input();

  public isMobile: Signal<boolean> = toSignal(this.viewportService.isMobile(), { initialValue: false });
  public currentImage: Signal<ProductImageModel> = computed(() => this._currentImage() ?? this.images()[0]);

  public changeImage(image: ProductImageModel): void {
    this._currentImage.set(image);
  }
}
